import requester from "web/script/modules/requester";
import _ from "underscore";
import url from "web/script/utils/url";


class SaveForLaterUtils {
    constructor() {
        this.sflProductIdsQueue = {};
        this.callServicesPinDebouce = _.debounce(this.saveForLaterPins, 50);
    }

    fetchSaveForLaterPins(productId) {
        return new Promise((resolve, reject) => {
            this.sflProductIdsQueue[productId] = { resolve, reject };
            this.callServicesPinDebouce();
        });
    }

    async saveForLaterPins() {
        const productIds = Object.keys(this.sflProductIdsQueue);

        const endpoint = "/services/pins/";
        const query = url.toURLSearchParams({
            product_id: [...productIds],
        });

        let data;

        try {
            data = await requester.get(endpoint, query);
        } catch (err) {
            for (const productId in this.sflProductIdsQueue) {
                const { reject } = this.sflProductIdsQueue[productId];
                reject(err);
            }
            return;
        }

        const { pin_mapping: pinMapping } = data;
        Object.entries(pinMapping).map(([productId, isSaved]) => {
            const { resolve } = this.sflProductIdsQueue[productId];
            resolve(isSaved);
        });

        this.sflProductIdsQueue = {};
    }
}

const saveForLaterUtils = new SaveForLaterUtils();

export default saveForLaterUtils;
